import { hasForbiddenSweepstakesWording } from "@simplyk/common";

export { getRaffleRestriction, isSweepstakesBaseEntryRateRequired, isSweepstakesCountry } from "@simplyk/common";

export const SWEEPSTAKES_LAWS_BY_STATE_URL = "https://www.zeffy.com/blog/sweepstakes-laws-by-state";
export const SWEEPSTAKES_FREE_ENTRY_URL = "https://www.zeffy.com/blog/sweepstakes-free-entry-amoe";
export const SWEEPSTAKES_OFFICIAL_RULES_URL = "https://www.zeffy.com/blog/sweepstakes-official-rules";
export const RAFFLE_LAWS_BY_STATE_URL = "https://www.zeffy.com/blog/raffle-laws-by-state";

export const containsRaffleWord = hasForbiddenSweepstakesWording;
